import { store } from "@/src/store";
import { toOfficeUrlForApi } from "@/src/utils/accessControl/formatOfficeUrl";

/**
 * Resolves `office_url` for qarshisu.net document create payloads.
 * Only from explicit value or Admission Office task/applicant context — no other fallbacks.
 * Always sent as domain only (`feu.com.ua`).
 */
export const resolveOfficeUrlForDocCreate = (explicit?: string | null): string | null => {
  const fromExplicit = toOfficeUrlForApi(explicit);
  if (fromExplicit) return fromExplicit;

  const fromContext = toOfficeUrlForApi(store.getState().admissionOfficeDoc.officeUrl);
  if (fromContext) return fromContext;

  return null;
};

/**
 * Adds `office_url` only when it came from the task/applicant.
 * Otherwise the field is omitted from the payload.
 */
export const withOfficeUrlForDocCreate = <T extends object>(data: T): T | (T & { office_url: string }) => {
  const record = data as T & { office_url?: string | null };
  const officeUrl = resolveOfficeUrlForDocCreate(record.office_url);
  if (officeUrl == null) return data;
  return { ...data, office_url: officeUrl };
};
